import { useState } from 'react'

import { useAppDispatch } from 'common/hooks/redux'

import { Topic } from '../interfaces'
import { addTopic, updateTopic } from '../store/topicsSlice'

export const useTopicHandlers = () => {
  const dispatch = useAppDispatch()
  const [editingTopicId, setEditingTopicId] = useState<string | null>(null)
  const [isAddingNewTopic, setIsAddingNewTopic] = useState(false)
  const [newTopicName, setNewTopicName] = useState('')

  const handleAddEmptyTopic = () => {
    setIsAddingNewTopic(true)
    setNewTopicName('')
  }

  const handleNewTopicSubmit = () => {
    if (newTopicName.trim() === '') {
      setIsAddingNewTopic(false)
      return
    }

    const newTopic: Topic = {
      id: `topic-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      category: 'user-defined',
      type: 'topic',
      name: newTopicName.trim(),
      original: {
        nodeId: Date.now(),
        node: '',
        nodeName: '',
        displayName: '',
      },
      isConstant: true,
    }

    dispatch(addTopic(newTopic))
    setIsAddingNewTopic(false)
    setNewTopicName('')
  }

  const handleNewTopicCancel = () => {
    setIsAddingNewTopic(false)
    setNewTopicName('')
  }

  const handleNewTopicKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      handleNewTopicSubmit()
    } else if (e.key === 'Escape') {
      e.preventDefault()
      handleNewTopicCancel()
    }
  }

  const handleEditClick = (topicId: string) => {
    setEditingTopicId(topicId)
  }

  const handleNameChange = (topicId: string, newName: string) => {
    dispatch(
      updateTopic({
        id: topicId,
        name: newName,
        configurationState: [],
      })
    )
    setEditingTopicId(null)
  }

  return {
    editingTopicId,
    isAddingNewTopic,
    newTopicName,
    setNewTopicName,
    setEditingTopicId,
    handleAddEmptyTopic,
    handleNewTopicSubmit,
    handleNewTopicKeyDown,
    handleEditClick,
    handleNameChange,
  }
}
